var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.records, border: "" } },
        [
          _c("el-table-column", {
            attrs: {
              prop: "sysPropertiesInfoId",
              label: "ID",
              width: "80",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "oldLineName",
              label: "老系统线路名称",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "newDestinationName",
              label: "新系统出发-目的地",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "jumpTime", label: "跳转日期", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { label: "编辑", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "delete",
                        attrs: { type: "text", icon: "el-icon-delete" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteClick(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticClass: "pagination-item",
        attrs: {
          background: "",
          layout: "prev, pager, next",
          total: _vm.total,
        },
        on: {
          "current-change": _vm.currentChange,
          "prev-click": _vm.prevClick,
          "next-click": _vm.nextClick,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }